class L {
  _pointer = 0;
  _eof = !1;
  _data;
  lastReadGroup;
  constructor(e) {
    this._data = e;
  }
  next() {
    if (!this.hasNext())
      throw this._eof ? new Error("Cannot call 'next' after EOF group has been read") : new Error(
        "Unexpected end of input: EOF group not read before end of file. Ended on code " + this._data[this._pointer]
      );
    const e = {
      code: parseInt(this._data[this._pointer])
    };
    return this._pointer++, e.value = m(e.code, this._data[this._pointer].trim()), this._pointer++, e.code === 0 && e.value === "EOF" && (this._eof = !0), this.lastReadGroup = e, e;
  }
  peek() {
    if (!this.hasNext())
      throw this._eof ? new Error("Cannot call 'peek' after EOF group has been read") : new Error(
        "Unexpected end of input: EOF group not read before end of file. Ended on code " + this._data[this._pointer]
      );
    const e = {
      code: parseInt(this._data[this._pointer])
    };
    return e.value = m(e.code, this._data[this._pointer + 1].trim()), e;
  }
  rewind(e = 1) {
    this._pointer = this._pointer - e * 2, this._eof = !1;
  }
  hasNext() {
    return !(this._eof || this._pointer > this._data.length - 2);
  }
  isEOF() {
    return this._eof;
  }
}
function m(t, e) {
  return t <= 9 ? e : t >= 10 && t <= 59 ? parseFloat(e) : t >= 60 && t <= 99 ? parseInt(e) : t >= 100 && t <= 109 ? e : t >= 110 && t <= 149 ? parseFloat(e) : t >= 160 && t <= 179 ? parseInt(e) : t >= 210 && t <= 239 || t >= 240 && t <= 259 ? parseFloat(e) : t >= 260 && t <= 269 || t >= 270 && t <= 289 ? parseInt(e) : t >= 290 && t <= 299 ? e === "1" : t >= 300 && t <= 369 ? e : t >= 370 && t <= 389 ? parseInt(e) : t >= 390 && t <= 399 ? e : t >= 400 && t <= 409 ? parseInt(e) : t >= 410 && t <= 419 ? e : t >= 420 && t <= 429 ? parseInt(e) : t >= 430 && t <= 439 ? e : t >= 440 && t <= 459 ? parseInt(e) : t >= 460 && t <= 469 ? parseFloat(e) : t >= 470 && t <= 481 || t === 999 || t >= 1e3 && t <= 1009 ? e : t >= 1010 && t <= 1059 ? parseFloat(e) : t >= 1060 && t <= 1071 ? parseInt(e) : e;
}
function T(t) {
  let e = null, a = null;
  const l = {};
  let i = t.next();
  for (; ; ) {
    if (i.code === 0 && i.value === "ENDSEC") {
      e && (l[e] = a);
      break;
    } else i.code === 9 ? (e && (l[e] = a), e = i.value) : i.code === 10 ? a = { x: i.value } : i.code === 20 ? a.y = i.value : i.code === 30 ? a.z = i.value : a = i.value;
    i = t.next();
  }
  return i = t.next(), l;
}
const F = [
  0,
  16711680,
  16776960,
  65280,
  65535,
  255,
  16711935,
  16777215,
  8421504,
  12632256,
  16711680,
  16744319,
  13369344,
  13395558,
  10027008,
  10046540,
  8323072,
  8339263,
  4980736,
  4990502,
  16727808,
  16752511,
  13382400,
  13401958,
  10036736,
  10051404,
  8331008,
  8343359,
  4985600,
  4992806,
  16744192,
  16760703,
  13395456,
  13408614,
  10046464,
  10056268,
  8339200,
  8347455,
  4990464,
  4995366,
  16760576,
  16768895,
  13408512,
  13415014,
  10056192,
  10061132,
  8347392,
  8351551,
  4995328,
  4997670,
  16776960,
  16777087,
  13421568,
  13421670,
  10000384,
  10000460,
  8355584,
  8355647,
  5000192,
  5000230,
  12582656,
  14679935,
  10079232,
  11717734,
  7510016,
  8755276,
  6258432,
  7307071,
  3755008,
  4344870,
  8388352,
  12582783,
  6736896,
  10079334,
  5019648,
  7510092,
  4161280,
  6258495,
  2509824,
  3755046,
  4194048,
  10485631,
  3394560,
  8375398,
  2529280,
  6264908,
  2064128,
  5209919,
  1264640,
  3099686,
  65280,
  8388479,
  52224,
  6736998,
  38912,
  5019724,
  32512,
  4161343,
  19456,
  2509862,
  65343,
  8388511,
  52275,
  6737023,
  38950,
  5019743,
  32543,
  4161359,
  19475,
  2509871,
  65407,
  8388543,
  52326,
  6737049,
  38988,
  5019762,
  32575,
  4161375,
  19494,
  2509881,
  65471,
  8388575,
  52377,
  6737074,
  39026,
  5019781,
  32607,
  4161391,
  19513,
  2509890,
  65535,
  8388607,
  52428,
  6737100,
  39064,
  5019800,
  32639,
  4161407,
  19532,
  2509900,
  49151,
  8380415,
  39372,
  6730444,
  29336,
  5014936,
  24447,
  4157311,
  14668,
  2507340,
  32767,
  8372223,
  26316,
  6724044,
  19608,
  5010072,
  16255,
  4153215,
  9804,
  2505036,
  16383,
  8364031,
  13260,
  6717388,
  9880,
  5005208,
  8063,
  4149119,
  4940,
  2502476,
  255,
  8355839,
  204,
  6710988,
  152,
  5000344,
  127,
  4145023,
  76,
  2500172,
  4129023,
  10452991,
  3342540,
  8349388,
  2490520,
  6245528,
  2031743,
  5193599,
  1245260,
  3089996,
  8323327,
  12550143,
  6684876,
  10053324,
  4980888,
  7490712,
  4128895,
  6242175,
  2490444,
  3745356,
  12517631,
  14647295,
  10027212,
  11691724,
  7471256,
  8735896,
  6226047,
  7290751,
  3735628,
  4335180,
  16711935,
  16744447,
  13369548,
  13395660,
  9961624,
  9981080,
  8323199,
  8339327,
  4980812,
  4990540,
  16711871,
  16744415,
  13369497,
  13395634,
  9961586,
  9981061,
  8323167,
  8339311,
  4980793,
  4990530,
  16711807,
  16744383,
  13369446,
  13395609,
  9961548,
  9981042,
  8323135,
  8339295,
  4980774,
  4990521,
  16711743,
  16744351,
  13369395,
  13395583,
  9961510,
  9981023,
  8323103,
  8339279,
  4980755,
  4990511,
  3355443,
  5987163,
  8684676,
  11382189,
  14079702,
  16777215
];
function A(t) {
  return F[t];
}
function n(t) {
  const e = {};
  t.rewind();
  let a = t.next(), l = a.code;
  if (e.x = a.value, l += 10, a = t.next(), a.code !== l)
    throw new Error("Expected code for point value to be " + l + " but got " + a.code + ".");
  return e.y = a.value, l += 10, a = t.next(), a.code !== l ? (t.rewind(), e) : (e.z = a.value, e);
}
function y(t, e) {
  const a = {}, l = e.code;
  a.x = e.value;
  const i = t.next();
  if (i.code === l + 10) {
    a.y = i.value;
    const s = t.next();
    s.code === l + 20 ? a.z = s.value : t.rewind();
  } else
    t.rewind();
  return a;
}
function f(t, e, a) {
  switch (e.code) {
    case 0:
      t.type = e.value;
      break;
    case 5:
      t.handle = e.value;
      break;
    case 6:
      t.lineType = e.value;
      break;
    case 8:
      t.layer = e.value;
      break;
    case 48:
      t.lineTypeScale = e.value;
      break;
    case 60:
      t.visible = e.value === 0;
      break;
    case 62:
      t.colorIndex = e.value;
      break;
    case 67:
      t.inPaperSpace = e.value !== 0;
      break;
    case 100:
      break;
    case 101:
      for (; e.code !== 0; )
        e = a.next();
      a.rewind();
      break;
    case 330:
      t.ownerHandle = e.value;
      break;
    case 347:
      t.materialObjectHandle = e.value;
      break;
    case 370:
      t.lineweight = e.value;
      break;
    case 420:
      t.color = e.value;
      break;
    case 1e3:
      t.extendedData || (t.extendedData = {}), t.extendedData.customStrings || (t.extendedData.customStrings = []), t.extendedData.customStrings.push(e.value);
      break;
    case 1001:
      t.extendedData || (t.extendedData = {}), t.extendedData.applicationName = e.value;
      break;
    default:
      return !1;
  }
  return !0;
}
function N(t) {
  const e = {};
  let a = t.next();
  const l = {
    VPORT: {
      tableRecordsProperty: "viewPorts",
      tableName: "viewPort",
      dxfSymbolName: "VPORT",
      parseTableRecords: () => _(t)
    },
    LTYPE: {
      tableRecordsProperty: "lineTypes",
      tableName: "lineType",
      dxfSymbolName: "LTYPE",
      parseTableRecords: () => H(t)
    },
    LAYER: {
      tableRecordsProperty: "layers",
      tableName: "layer",
      dxfSymbolName: "LAYER",
      parseTableRecords: () => C(t)
    },
    STYLE: {
      tableRecordsProperty: "styles",
      tableName: "style",
      dxfSymbolName: "STYLE",
      parseTableRecords: () => V(t)
    },
    BLOCK_RECORD: {
      tableRecordsProperty: "blockRecords",
      tableName: "blockRecord",
      dxfSymbolName: "BLOCK_RECORD",
      parseTableRecords: () => M(t)
    },
    DIMSTYLE: {
      tableRecordsProperty: "dimStyles",
      tableName: "dimStyle",
      dxfSymbolName: "DIMSTYLE",
      parseTableRecords: () => B(t)
    }
  };
  for (; a.value !== "EOF" && !(a.code === 0 && a.value === "ENDSEC"); )
    if (a.code === 0 && a.value === "TABLE") {
      a = t.next();
      const i = l[a.value];
      if (i)
        e[i.tableName] = I(t, a, i), a = t.lastReadGroup;
      else {
        for (; !t.isEOF() && (a = t.next(), !(a.code === 0 && a.value === "ENDTAB")); )
          ;
        a = t.next();
      }
    } else
      a = t.next();
  return a = t.next(), e;
}
function I(t, e, a) {
  const l = {};
  let i = t.next();
  for (; !(i.code === 0 && i.value === "ENDTAB"); )
    switch (i.code) {
      case 5:
        l.handle = i.value, i = t.next();
        break;
      case 330:
        l.ownerHandle = i.value, i = t.next();
        break;
      case 100:
        i = t.next();
        break;
      case 70:
        i = t.next();
        break;
      case 0:
        i.value === a.dxfSymbolName ? (l[a.tableRecordsProperty] = a.parseTableRecords(), i = t.lastReadGroup) : i = t.next();
        break;
      default:
        i = t.next();
    }
  return i = t.next(), l;
}
function C(t) {
  const e = {};
  let a = { visible: !0, frozen: !1, locked: !1 }, l, i = t.next();
  for (; !(i.code === 0 && i.value === "ENDTAB"); )
    switch (i.code) {
      case 2:
        a.name = i.value, l = i.value, i = t.next();
        break;
      case 6:
        a.lineType = i.value, i = t.next();
        break;
      case 62:
        a.visible = i.value >= 0, a.colorIndex = Math.abs(i.value), a.color = A(a.colorIndex), i = t.next();
        break;
      case 70: {
        const s = i.value;
        a.frozen = (s & 1) !== 0, a.locked = (s & 4) !== 0, i = t.next();
        break;
      }
      case 0:
        i.value === "LAYER" && (e[l] = a, a = { visible: !0, frozen: !1, locked: !1 }, l = void 0), i = t.next();
        break;
      default:
        i = t.next();
        break;
    }
  return l && (e[l] = a), e;
}
function H(t) {
  const e = {};
  let a = {}, l = 0, i = "", s = t.next();
  for (; !(s.code === 0 && s.value === "ENDTAB"); )
    switch (s.code) {
      case 2:
        a.name = s.value, i = s.value, s = t.next();
        break;
      case 3:
        a.description = s.value, s = t.next();
        break;
      case 73:
        l = s.value, l > 0 && (a.pattern = []), s = t.next();
        break;
      case 40:
        a.patternLength = s.value, s = t.next();
        break;
      case 49:
        a.pattern.push(s.value), s = t.next();
        break;
      case 0:
        e[i] = a, a = {}, s = t.next();
        break;
      default:
        s = t.next();
    }
  return e[i] = a, e;
}
function V(t) {
  const e = {};
  let a = {}, l = "", i = t.next();
  for (; !(i.code === 0 && i.value === "ENDTAB"); )
    switch (i.code) {
      case 2:
        a.name = i.value, l = i.value, i = t.next();
        break;
      case 5:
        a.handle = i.value.toUpperCase(), i = t.next();
        break;
      case 3:
        a.fontFile = i.value, i = t.next();
        break;
      case 4:
        a.bigFont = i.value, i = t.next();
        break;
      case 40:
        a.fixedHeight = i.value, i = t.next();
        break;
      case 41:
        a.widthFactor = i.value, i = t.next();
        break;
      case 1071: {
        const s = i.value;
        s >>> 25 & 1 && (a.bold = !0), s >>> 24 & 1 && (a.italic = !0), i = t.next();
        break;
      }
      case 0:
        i.value === "STYLE" && (l && (e[l] = a), a = {}, l = ""), i = t.next();
        break;
      default:
        i = t.next();
        break;
    }
  return l && (e[l] = a), e;
}
function _(t) {
  const e = [];
  let a = {}, l = t.next();
  for (; !(l.code === 0 && l.value === "ENDTAB"); )
    switch (l.code) {
      case 2:
        a.name = l.value, l = t.next();
        break;
      case 10:
        a.lowerLeftCorner = y(t, l), l = t.next();
        break;
      case 11:
        a.upperRightCorner = y(t, l), l = t.next();
        break;
      case 12:
        a.center = y(t, l), l = t.next();
        break;
      case 45:
        a.viewHeight = l.value, l = t.next();
        break;
      case 330:
        a.ownerHandle = l.value, l = t.next();
        break;
      case 0:
        l.value === "VPORT" && (e.push(a), a = {}), l = t.next();
        break;
      default:
        l = t.next();
        break;
    }
  return e.push(a), e;
}
function M(t) {
  const e = {};
  let a = {}, l = "", i = t.next();
  for (; !(i.code === 0 && i.value === "ENDTAB"); )
    switch (i.code) {
      case 2:
        a.name = i.value, l = i.value, i = t.next();
        break;
      case 5:
        a.handle = i.value, i = t.next();
        break;
      case 70:
        a.units = i.value, i = t.next();
        break;
      case 0:
        i.value === "BLOCK_RECORD" && (l && (e[l] = a), a = {}, l = ""), i = t.next();
        break;
      default:
        i = t.next();
        break;
    }
  return l && (e[l] = a), e;
}
function B(t) {
  const e = {};
  let a = {}, l = "", i = t.next();
  for (; !(i.code === 0 && i.value === "ENDTAB"); )
    switch (i.code) {
      case 2:
        a.name = i.value, l = i.value, i = t.next();
        break;
      case 40:
        a.dimscale = i.value, i = t.next();
        break;
      case 41:
        a.dimasz = i.value, i = t.next();
        break;
      case 44:
        a.dimexe = i.value, i = t.next();
        break;
      case 73:
        a.dimtoh = i.value, i = t.next();
        break;
      case 74:
        a.dimtih = i.value, i = t.next();
        break;
      case 77:
        a.dimtad = i.value, i = t.next();
        break;
      case 78:
        a.dimzin = i.value, i = t.next();
        break;
      case 140:
        a.dimtxt = i.value, i = t.next();
        break;
      case 142:
        a.dimtsz = i.value, i = t.next();
        break;
      case 147:
        a.dimgap = i.value, i = t.next();
        break;
      case 176:
        a.dimclrd = i.value, i = t.next();
        break;
      case 177:
        a.dimclre = i.value, i = t.next();
        break;
      case 178:
        a.dimclrt = i.value, i = t.next();
        break;
      case 271:
        a.dimdec === void 0 && (a.dimdec = i.value), i = t.next();
        break;
      case 179:
        a.dimadec = i.value, i = t.next();
        break;
      case 277:
        a.dimlunit = i.value, i = t.next();
        break;
      case 279:
        a.dimtmove = i.value, i = t.next();
        break;
      case 288:
        a.dimupt = i.value, i = t.next();
        break;
      case 289:
        a.dimatfit = i.value, i = t.next();
        break;
      case 340:
        a.dimtxstyHandle = i.value.toUpperCase(), i = t.next();
        break;
      case 341:
        a.dimldrblkHandle = i.value, i = t.next();
        break;
      case 342:
        a.dimblkHandle = i.value, i = t.next();
        break;
      case 0:
        i.value === "DIMSTYLE" && (l && (e[l] = a), a = {}, l = ""), i = t.next();
        break;
      default:
        i = t.next();
        break;
    }
  return l && (e[l] = a), e;
}
function G(t, e) {
  const a = { type: e.value, vertices: [] };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 10:
        a.vertices.unshift(n(t));
        break;
      case 11:
        a.vertices.push(n(t));
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      case 100:
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function Y(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 10:
        a.center = n(t);
        break;
      case 40:
        a.radius = e.value;
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function z(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 10:
        a.center = n(t);
        break;
      case 40:
        a.radius = e.value;
        break;
      case 50:
        a.startAngle = Math.PI / 180 * e.value;
        break;
      case 51:
        a.endAngle = Math.PI / 180 * e.value, a.angleLength = a.endAngle - a.startAngle;
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function X(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 10:
        a.position = n(t);
        break;
      case 39:
        a.thickness = e.value;
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      case 100:
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function U(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 10:
        a.center = n(t);
        break;
      case 11:
        a.majorAxisEndPoint = n(t);
        break;
      case 40:
        a.axisRatio = e.value;
        break;
      case 41:
        a.startAngle = e.value;
        break;
      case 42:
        a.endAngle = e.value;
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function j(t, e) {
  const a = { type: e.value, points: [] };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 10:
        a.points[0] = n(t);
        break;
      case 11:
        a.points[1] = n(t);
        break;
      case 12:
        a.points[2] = n(t);
        break;
      case 13:
        a.points[3] = n(t);
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function W(t, e) {
  const a = { type: e.value, vertices: [] };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 70:
        a.edgeFlags = e.value;
        break;
      case 10:
        a.vertices = K(t, e), e = t.lastReadGroup;
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function K(t, e) {
  const a = [];
  let l = !1, i = !1;
  const s = 4;
  for (let b = 0; b < s; b++) {
    const o = {};
    for (; !t.isEOF() && !(e.code === 0 || i); ) {
      switch (e.code) {
        case 10:
        case 11:
        case 12:
        case 13:
          if (l) {
            i = !0;
            continue;
          }
          o.x = e.value, l = !0;
          break;
        case 20:
        case 21:
        case 22:
        case 23:
          o.y = e.value;
          break;
        case 30:
        case 31:
        case 32:
        case 33:
          o.z = e.value;
          break;
        default:
          return a;
      }
      e = t.next();
    }
    a.push(o), l = !1, i = !1;
  }
  return t.rewind(), a;
}
function q(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 10:
        a.startPoint = n(t);
        break;
      case 11:
        a.endPoint = n(t);
        break;
      case 40:
        a.textHeight = e.value;
        break;
      case 41:
        a.xScale = e.value;
        break;
      case 50:
        a.rotation = e.value;
        break;
      case 1:
        a.text = e.value;
        break;
      case 7:
        a.textStyle = e.value;
        break;
      case 72:
        a.halign = e.value;
        break;
      case 73:
        a.valign = e.value;
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function J(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 3:
        a.text ? a.text += e.value : a.text = e.value;
        break;
      case 1:
        a.text ? a.text += e.value : a.text = e.value;
        break;
      case 7:
        a.textStyle = e.value;
        break;
      case 10:
        a.position = n(t);
        break;
      case 11:
        a.directionVector = n(t);
        break;
      case 40:
        a.height = e.value;
        break;
      case 41:
        a.width = e.value;
        break;
      case 50:
        a.rotation = e.value;
        break;
      case 71:
        a.attachmentPoint = e.value;
        break;
      case 72:
        a.drawingDirection = e.value;
        break;
      case 44:
        a.lineSpacingFactor = e.value;
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function $(t, e) {
  const a = {
    type: e.value,
    scale: 1,
    textStyle: "STANDARD"
  };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 1:
        a.text = e.value;
        break;
      case 2:
        a.tag = e.value;
        break;
      case 3:
        a.prompt = e.value;
        break;
      case 7:
        a.textStyle = e.value;
        break;
      case 10:
        a.startPoint = n(t);
        break;
      case 11:
        a.endPoint = n(t);
        break;
      case 39:
        a.thickness = e.value;
        break;
      case 40:
        a.textHeight = e.value;
        break;
      case 41:
        a.scale = e.value;
        break;
      case 50:
        a.rotation = e.value;
        break;
      case 51:
        a.obliqueAngle = e.value;
        break;
      case 70:
        a.invisible = !!(e.value & 1), a.constant = !!(e.value & 2), a.verificationRequired = !!(e.value & 4), a.preset = !!(e.value & 8);
        break;
      case 71:
        a.backwards = !!(e.value & 2), a.mirrored = !!(e.value & 4);
        break;
      case 72:
        a.horizontalJustification = e.value;
        break;
      case 73:
        a.fieldLength = e.value;
        break;
      case 74:
        a.verticalJustification = e.value;
        break;
      case 100:
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function Q(t, e) {
  const a = {
    type: e.value,
    scale: 1,
    textStyle: "STANDARD"
  };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 1:
        a.text = e.value;
        break;
      case 2:
        a.tag = e.value;
        break;
      case 7:
        a.textStyle = e.value;
        break;
      case 10:
        a.startPoint = n(t);
        break;
      case 11:
        a.endPoint = n(t);
        break;
      case 39:
        a.thickness = e.value;
        break;
      case 40:
        a.textHeight = e.value;
        break;
      case 41:
        a.scale = e.value;
        break;
      case 50:
        a.rotation = e.value;
        break;
      case 51:
        a.obliqueAngle = e.value;
        break;
      case 70:
        a.invisible = !!(e.value & 1), a.constant = !!(e.value & 2), a.verificationRequired = !!(e.value & 4), a.preset = !!(e.value & 8);
        break;
      case 71:
        a.backwards = !!(e.value & 2), a.mirrored = !!(e.value & 4);
        break;
      case 72:
        a.horizontalJustification = e.value;
        break;
      case 73:
        a.fieldLength = e.value;
        break;
      case 74:
        a.verticalJustification = e.value;
        break;
      case 100:
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function Z(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF(); ) {
    if (e.code === 0) {
      if (e.value === "ATTRIB") {
        const l = [];
        for (; !t.isEOF() && e.code === 0 && e.value === "ATTRIB"; )
          l.push(Q(t, e)), e = t.lastReadGroup;
        l.length > 0 && (a.attribs = l), e.code === 0 && e.value === "SEQEND" && (e = t.next());
      }
      break;
    }
    switch (e.code) {
      case 2:
        a.name = e.value;
        break;
      case 41:
        a.xScale = e.value;
        break;
      case 42:
        a.yScale = e.value;
        break;
      case 43:
        a.zScale = e.value;
        break;
      case 10:
        a.position = n(t);
        break;
      case 50:
        a.rotation = e.value;
        break;
      case 70:
        a.columnCount = e.value;
        break;
      case 71:
        a.rowCount = e.value;
        break;
      case 44:
        a.columnSpacing = e.value;
        break;
      case 45:
        a.rowSpacing = e.value;
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function ee(t, e) {
  let a = e.next();
  if (!(a.code !== 1e3 || a.value !== "DSTYLE") && (a = e.next(), !(a.code !== 1002 || a.value !== "{")))
    for (a = e.next(); !e.isEOF() && !(a.code === 1002 && a.value === "}") && a.code !== 0; ) {
      if (a.code === 1070) {
        const l = a.value;
        if (a = e.next(), a.code === 0 || a.code === 1002 && a.value === "}") break;
        const i = a.value;
        switch (l) {
          case 140:
            t.textHeight || (t.textHeight = i);
            break;
          case 41:
            t.arrowSize = i;
            break;
          case 40:
            t.dimScale = i;
            break;
          case 271:
            t.dimdec = i;
            break;
          case 179:
            t.dimadec = i;
            break;
        }
      }
      a = e.next();
    }
}
function te(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 2:
        a.block = e.value;
        break;
      case 3:
        a.styleName = e.value;
        break;
      case 10:
        a.anchorPoint = n(t);
        break;
      case 11:
        a.middleOfText = n(t);
        break;
      case 12:
        a.insertionPoint = n(t);
        break;
      case 13:
        a.linearOrAngularPoint1 = n(t);
        break;
      case 14:
        a.linearOrAngularPoint2 = n(t);
        break;
      case 15:
        a.diameterOrRadiusPoint = n(t);
        break;
      case 16:
        a.arcPoint = n(t);
        break;
      case 70:
        a.dimensionType = e.value;
        break;
      case 71:
        a.attachmentPoint = e.value;
        break;
      case 42:
        a.actualMeasurement = e.value;
        break;
      case 1:
        a.text = e.value;
        break;
      case 140:
        a.textHeight = e.value;
        break;
      case 50:
        a.angle = e.value;
        break;
      case 1001:
        if (e.value === "ACAD") {
          ee(a, t), e = t.lastReadGroup;
          continue;
        }
        f(a, e, t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function g(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 10:
        a.controlPoints || (a.controlPoints = []), a.controlPoints.push(n(t));
        break;
      case 11:
        a.fitPoints || (a.fitPoints = []), a.fitPoints.push(n(t));
        break;
      case 12:
        a.startTangent = n(t);
        break;
      case 13:
        a.endTangent = n(t);
        break;
      case 40:
        a.knotValues || (a.knotValues = []), a.knotValues.push(e.value);
        break;
      case 41:
        a.weights || (a.weights = []), a.weights.push(e.value);
        break;
      case 70:
        (e.value & 1) !== 0 && (a.closed = !0), (e.value & 2) !== 0 && (a.periodic = !0), (e.value & 4) !== 0 && (a.rational = !0), (e.value & 8) !== 0 && (a.planar = !0), (e.value & 16) !== 0 && (a.planar = !0, a.linear = !0);
        break;
      case 71:
        a.degreeOfSplineCurve = e.value;
        break;
      case 72:
        a.numberOfKnots = e.value;
        break;
      case 73:
        a.numberOfControlPoints = e.value;
        break;
      case 74:
        a.numberOfFitPoints = e.value;
        break;
      case 210:
        a.normalVector = n(t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function ae(t, e) {
  const a = { type: e.value, vertices: [] };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 10:
        break;
      case 20:
        break;
      case 30:
        break;
      case 39:
        a.thickness = e.value;
        break;
      case 40:
        a.defaultStartWidth = e.value;
        break;
      case 41:
        a.defaultEndWidth = e.value;
        break;
      case 70:
        a.shape = (e.value & 1) !== 0, a.includesCurveFitVertices = (e.value & 2) !== 0, a.includesSplineFitVertices = (e.value & 4) !== 0, a.is3dPolyline = (e.value & 8) !== 0, a.is3dPolygonMesh = (e.value & 16) !== 0, a.is3dPolygonMeshClosed = (e.value & 32) !== 0, a.isPolyfaceMesh = (e.value & 64) !== 0, a.hasContinuousLinetypePattern = (e.value & 128) !== 0;
        break;
      case 71:
        a.meshMVertexCount = e.value;
        break;
      case 72:
        a.meshNVertexCount = e.value;
        break;
      case 73:
      case 74:
      case 75:
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a.vertices = ie(t, e), a;
}
function ie(t, e) {
  const a = [];
  for (; !t.isEOF(); )
    if (e.code === 0)
      if (e.value === "VERTEX")
        a.push(le(t, e)), e = t.lastReadGroup;
      else if (e.value === "SEQEND") {
        se(t, e);
        break;
      } else
        break;
    else
      e = t.next();
  return a;
}
function le(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 10:
        a.x = e.value;
        break;
      case 20:
        a.y = e.value;
        break;
      case 30:
        a.z = e.value;
        break;
      case 40:
        e.value !== 0 && (a.startWidth = e.value);
        break;
      case 41:
        e.value !== 0 && (a.endWidth = e.value);
        break;
      case 42:
        e.value !== 0 && (a.bulge = e.value);
        break;
      case 70:
        a.vertexFlags = e.value;
        break;
      case 50:
        break;
      case 71:
        a.faceA = e.value;
        break;
      case 72:
        a.faceB = e.value;
        break;
      case 73:
        a.faceC = e.value;
        break;
      case 74:
        a.faceD = e.value;
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function se(t, e) {
  for (e = t.next(); !t.isEOF() && e.code !== 0; )
    f({ type: "SEQEND" }, e, t), e = t.next();
}
function oe(t, e) {
  const a = { type: e.value, vertices: [] };
  let l = 0;
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 38:
        a.elevation = e.value;
        break;
      case 39:
        a.depth = e.value;
        break;
      case 70:
        a.shape = (e.value & 1) === 1, a.hasContinuousLinetypePattern = (e.value & 128) === 128;
        break;
      case 90:
        l = e.value;
        break;
      case 10:
        a.vertices = ne(l, t);
        break;
      case 43:
        e.value !== 0 && (a.width = e.value);
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function ne(t, e) {
  if (!t || t <= 0) throw Error("n must be greater than 0 vertices");
  const a = [];
  let l = !1, i = !1, s = e.lastReadGroup;
  for (let b = 0; b < t; b++) {
    const o = {};
    for (; !e.isEOF() && !(s.code === 0 || i); ) {
      switch (s.code) {
        case 10:
          if (l) {
            i = !0;
            continue;
          }
          o.x = s.value, l = !0;
          break;
        case 20:
          o.y = s.value;
          break;
        case 30:
          o.z = s.value;
          break;
        case 40:
          o.startWidth = s.value;
          break;
        case 41:
          o.endWidth = s.value;
          break;
        case 42:
          s.value !== 0 && (o.bulge = s.value);
          break;
        case 91:
          break;
        default:
          return e.rewind(), l && a.push(o), a;
      }
      s = e.next();
    }
    a.push(o), l = !1, i = !1;
  }
  return e.rewind(), a;
}
function D(t, e, a) {
  if (e.code !== 97) return e;
  const l = e.value, i = [];
  e = t.next();
  for (let s = 0; s < l && e.code === 330; s++)
    i.push(String(e.value).toUpperCase()), e = t.next();
  return i.length > 0 && (a.sourceObjectHandles = i), e;
}
function be(t, e) {
  const a = [];
  if (e.code !== 93)
    return { path: { edges: a }, curr: e };
  const l = e.value;
  e = t.next();
  for (let s = 0; s < l && e.code === 72; s++) {
    const b = e.value;
    if (e = t.next(), b === 1) {
      let o = 0, d = 0, u = 0, k = 0;
      for (; e.code !== 0 && e.code !== 72 && e.code !== 92 && e.code !== 93 && e.code !== 97; ) {
        switch (e.code) {
          case 10:
            o = e.value;
            break;
          case 20:
            d = e.value;
            break;
          case 11:
            u = e.value;
            break;
          case 21:
            k = e.value;
            break;
        }
        if (e.code === 21) {
          e = t.next();
          break;
        }
        e = t.next();
      }
      a.push({
        type: "line",
        start: { x: o, y: d },
        end: { x: u, y: k }
      });
    } else if (b === 2) {
      let o = 0, d = 0, u = 0, k = 0, v = 0, p = !1;
      for (; e.code !== 0 && e.code !== 72 && e.code !== 92 && e.code !== 93 && e.code !== 97; ) {
        switch (e.code) {
          case 10:
            o = e.value;
            break;
          case 20:
            d = e.value;
            break;
          case 40:
            u = e.value;
            break;
          case 50:
            k = e.value;
            break;
          case 51:
            v = e.value;
            break;
          case 73:
            p = e.value !== 0;
            break;
        }
        if (e.code === 73) {
          e = t.next();
          break;
        }
        e = t.next();
      }
      a.push({
        type: "arc",
        center: { x: o, y: d },
        radius: u,
        startAngle: k,
        endAngle: v,
        ccw: p
      });
    } else if (b === 3) {
      let o = 0, d = 0, u = 0, k = 0, v = 1, p = 0, x = 0, h = !1;
      for (; e.code !== 0 && e.code !== 72 && e.code !== 92 && e.code !== 93 && e.code !== 97; ) {
        switch (e.code) {
          case 10:
            o = e.value;
            break;
          case 20:
            d = e.value;
            break;
          case 11:
            u = e.value;
            break;
          case 21:
            k = e.value;
            break;
          case 40:
            v = e.value;
            break;
          case 50:
            p = e.value;
            break;
          case 51:
            x = e.value;
            break;
          case 73:
            h = e.value !== 0;
            break;
        }
        if (e.code === 73) {
          e = t.next();
          break;
        }
        e = t.next();
      }
      a.push({
        type: "ellipse",
        center: { x: o, y: d },
        majorAxisEndPoint: { x: u, y: k },
        axisRatio: v,
        startAngle: p,
        endAngle: x,
        ccw: h
      });
    } else if (b === 4) {
      let o = 3, d = 0, u = 0;
      const k = [], v = [], p = [], x = [];
      for (; e.code !== 0 && e.code !== 72 && e.code !== 92 && e.code !== 93 && e.code !== 75 && e.code !== 76 && e.code !== 98; ) {
        switch (e.code) {
          case 94:
            o = e.value;
            break;
          case 73:
            break;
          // rational flag
          case 74:
            break;
          // periodic flag
          case 95:
            break;
          // numKnots -- informational, actual count derived from code 40 occurrences
          case 96:
            d = e.value;
            break;
          case 40:
            k.push(e.value);
            break;
          case 10: {
            if (d > 0 && v.length >= d) break;
            const E = e.value;
            e = t.next();
            const w = e.code === 20 ? e.value : 0;
            v.push({ x: E, y: w });
            break;
          }
          case 42:
            p.push(e.value);
            break;
          case 97:
            u = e.value;
            break;
          case 11: {
            if (u > 0 && x.length >= u) break;
            const E = e.value;
            e = t.next();
            const w = e.code === 21 ? e.value : 0;
            x.push({ x: E, y: w });
            break;
          }
        }
        e = t.next();
      }
      const h = {
        type: "spline",
        degree: o,
        knots: k,
        controlPoints: v
      };
      p.length > 0 && (h.weights = p), x.length > 0 && (h.fitPoints = x), a.push(h);
    } else
      for (; e.code !== 0 && e.code !== 72 && e.code !== 92 && e.code !== 93 && e.code !== 97; )
        e = t.next();
  }
  const i = { edges: a };
  return e = D(t, e, i), { path: i, curr: e };
}
function fe(t, e) {
  const a = [];
  let l = !1;
  e.code === 72 && (l = e.value !== 0, e = t.next());
  let i = !1;
  e.code === 73 && (i = e.value !== 0, e = t.next());
  let s = 0;
  e.code === 93 && (s = e.value, e = t.next());
  for (let o = 0; o < s; o++) {
    let d = 0, u = 0, k = 0;
    e.code === 10 && (d = e.value, e = t.next()), e.code === 20 && (u = e.value, e = t.next()), l && e.code === 42 && (k = e.value, e = t.next());
    const v = { x: d, y: u };
    k !== 0 && (v.bulge = k), a.push(v);
  }
  if (i && a.length > 0) {
    const o = a[0];
    a.push({ x: o.x, y: o.y, bulge: o.bulge });
  }
  const b = { polylineVertices: a };
  return e = D(t, e, b), { path: b, curr: e };
}
function de(t, e, a) {
  const l = [];
  for (let i = 0; i < a; i++) {
    const s = {
      angle: 0,
      basePoint: { x: 0, y: 0 },
      offset: { x: 0, y: 0 },
      dashes: []
    };
    let b = 0;
    e.code === 53 && (s.angle = e.value, e = t.next()), e.code === 43 && (s.basePoint.x = e.value, e = t.next()), e.code === 44 && (s.basePoint.y = e.value, e = t.next()), e.code === 45 && (s.offset.x = e.value, e = t.next()), e.code === 46 && (s.offset.y = e.value, e = t.next()), e.code === 79 && (b = e.value, e = t.next());
    for (let o = 0; o < b; o++)
      e.code === 49 && (s.dashes.push(e.value), e = t.next());
    l.push(s);
  }
  return { lines: l, curr: e };
}
function ke(t, e) {
  const a = {
    type: "HATCH",
    patternName: "",
    solid: !1,
    boundaryPaths: []
  };
  e = t.next();
  let l = 0, i = 0;
  for (; !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 2:
        a.patternName = e.value;
        break;
      case 70:
        a.solid = e.value === 1;
        break;
      case 91:
        l = e.value;
        break;
      case 92: {
        if (i >= l) break;
        const s = e.value;
        if (e = t.next(), s & 2) {
          const b = fe(t, e);
          a.boundaryPaths.push(b.path), e = b.curr;
        } else {
          const b = be(t, e);
          a.boundaryPaths.push(b.path), e = b.curr;
        }
        i++;
        continue;
      }
      case 75:
        a.style = e.value;
        break;
      case 41:
        a.patternScale = e.value;
        break;
      case 52:
        a.patternAngle = e.value;
        break;
      case 78: {
        const s = e.value;
        if (s > 0) {
          e = t.next();
          const b = de(t, e, s);
          a.patternLines = b.lines, e = b.curr;
          continue;
        }
        break;
      }
      case 210:
        a.extrusionDirection = n(t);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
const r = 41;
function ue(t, e) {
  const a = { type: e.value, vertices: [] };
  e = t.next();
  let l = !1, i = null;
  for (; !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 3:
        a.styleName = e.value;
        break;
      case 10:
        a.vertices.push(n(t));
        break;
      case 71:
        a.arrowHeadFlag = e.value;
        break;
      case 72:
        a.pathType = e.value;
        break;
      case 76:
        a.numVertices = e.value;
        break;
      case 340:
        a.annotationHandle = e.value;
        break;
      case 100:
        break;
      // XDATA DSTYLE: extract DIMASZ override
      case 1e3:
        l = e.value === "DSTYLE";
        break;
      case 1002:
        e.value === "}" && (l = !1, i = null);
        break;
      case 1070:
        l && (i === null ? i = e.value : (i === r && (a.arrowSize = e.value), i = null));
        break;
      case 1040:
        l && i !== null && (i === r && (a.arrowSize = e.value), i = null);
        break;
      case 1005:
        l && (i = null);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function O(t, e) {
  const a = {
    type: "MULTILEADER",
    leaders: [],
    hasArrowHead: !0
  };
  e = t.next();
  let l = !1, i = !1, s = !1, b = null, o = null;
  for (; !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 300:
        l = !0;
        break;
      case 301:
        l = !1;
        break;
      case 302: {
        e.value === "LEADER{" && (i = !0, b = { lines: [] });
        break;
      }
      case 303: {
        i && b && (b.lines.length > 0 && a.leaders.push(b), b = null, i = !1);
        break;
      }
      case 304: {
        const d = e.value;
        d === "LEADER_LINE{" ? (s = !0, o = { vertices: [] }) : i || (a.text = d);
        break;
      }
      case 305: {
        s && o && (b && o.vertices.length > 0 && b.lines.push(o), o = null, s = !1);
        break;
      }
      case 10:
        s && o ? o.vertices.push(n(t)) : i && b && (b.lastLeaderPoint = n(t));
        break;
      case 11:
        i && b && !s && (b.doglegVector = n(t));
        break;
      case 12:
        l && !i && (a.textPosition = n(t));
        break;
      case 40:
        i && b && !s && (b.doglegLength = e.value);
        break;
      case 41:
        l && !i && (a.textHeight = e.value);
        break;
      case 42:
        l || (a.arrowSize = e.value);
        break;
      case 170:
        l || (a.leaderLineType = e.value);
        break;
      case 90:
        l && !i ? a.textColorRaw = e.value : l || (a.propertyOverrideFlag = e.value);
        break;
      case 91:
        l || (a.leaderLineColorRaw = e.value);
        break;
      case 340:
        l || (a.styleHandle = String(e.value).toUpperCase());
        break;
      case 100:
        break;
      case 171:
        l || (a.hasArrowHead = e.value !== 0);
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function ve(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; )
    f(a, e, t), e = t.next();
  return a;
}
function pe(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; )
    f(a, e, t), e = t.next();
  return a;
}
function xe(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; )
    f(a, e, t), e = t.next();
  return a;
}
function he(t, e) {
  const a = {
    type: e.value,
    scale: 1,
    justification: 0,
    flags: 0,
    numVertices: 0,
    numElements: 0,
    vertices: []
  };
  let l = null, i = null;
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 2:
        a.styleName = e.value;
        break;
      case 40:
        a.scale = e.value;
        break;
      case 70:
        a.justification = e.value;
        break;
      case 71:
        a.flags = e.value;
        break;
      case 72:
        a.numVertices = e.value;
        break;
      case 73:
        a.numElements = e.value;
        break;
      case 10:
        break;
      case 20:
      case 30:
        break;
      case 11:
        l = {
          x: 0,
          y: 0,
          z: 0,
          direction: { x: 0, y: 0, z: 0 },
          miter: { x: 0, y: 0, z: 0 },
          elementParams: []
        }, a.vertices.push(l), l.x = e.value;
        break;
      case 21:
        l && (l.y = e.value);
        break;
      case 31:
        l && (l.z = e.value);
        break;
      case 12:
        l && (l.direction = n(t));
        break;
      case 13:
        l && (l.miter = n(t));
        break;
      case 74:
        i = { params: [] }, l && l.elementParams.push(i);
        break;
      case 41:
        i && i.params.push(e.value);
        break;
      case 75:
      case 42:
        break;
      case 210:
        a.extrusionDirection = n(t);
        break;
      case 100:
      case 340:
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function P(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; ) {
    switch (e.code) {
      case 10:
        a.basePoint = n(t);
        break;
      case 11:
        a.direction = n(t);
        break;
      case 100:
        break;
      default:
        f(a, e, t);
        break;
    }
    e = t.next();
  }
  return a;
}
function ce(t, e) {
  const a = { type: e.value };
  for (e = t.next(); !t.isEOF() && e.code !== 0; )
    f(a, e, t), e = t.next();
  return a;
}
function ye(t, e) {
  const a = { type: "REGION" };
  for (e = t.next(); !t.isEOF() && e.code !== 0; )
    f(a, e, t), e = t.next();
  return a;
}
const Ee = {
  LINE: G,
  CIRCLE: Y,
  ARC: z,
  POINT: X,
  ELLIPSE: U,
  SOLID: j,
  "3DFACE": W,
  TEXT: q,
  MTEXT: J,
  ATTDEF: $,
  INSERT: Z,
  DIMENSION: te,
  SPLINE: g,
  HELIX: (t, e) => {
    const a = g(t, { ...e, value: "SPLINE" });
    return a.numberOfControlPoints && a.controlPoints && (a.controlPoints = a.controlPoints.slice(0, a.numberOfControlPoints)), a.numberOfKnots && a.knotValues && (a.knotValues = a.knotValues.slice(0, a.numberOfKnots)), a.numberOfFitPoints !== void 0 && a.fitPoints && (a.fitPoints = a.fitPoints.slice(0, a.numberOfFitPoints)), a.numberOfControlPoints && a.weights && (a.weights = a.weights.slice(0, a.numberOfControlPoints)), a;
  },
  POLYLINE: ae,
  LWPOLYLINE: oe,
  HATCH: ke,
  LEADER: ue,
  MULTILEADER: O,
  MLEADER: O,
  VIEWPORT: ve,
  IMAGE: pe,
  WIPEOUT: xe,
  MLINE: he,
  XLINE: P,
  RAY: P,
  "3DSOLID": ce,
  REGION: ye
};
function R(t, e) {
  const a = [], l = e ? "ENDBLK" : "ENDSEC";
  let i = 0, s;
  for (e ? s = t.lastReadGroup : s = t.next(); !t.isEOF(); )
    if (s.code === 0) {
      if (s.value === l)
        break;
      const b = Ee[s.value];
      if (b)
        try {
          const o = b(t, s);
          s = t.lastReadGroup, o.handle || (o.handle = i++), a.push(o);
        } catch (o) {
          for (console.warn(
            `Failed to parse entity "${s.value}":`,
            o instanceof Error ? o.message : o
          ), s = t.lastReadGroup; !t.isEOF() && s.code !== 0; )
            s = t.next();
        }
      else {
        s = t.next();
        continue;
      }
    } else
      s = t.next();
  return l === "ENDSEC" && (s = t.next()), a;
}
function we(t) {
  const e = {};
  let a = 0, l = t.next();
  for (; l.value !== "EOF" && !(l.code === 0 && l.value === "ENDSEC"); )
    if (l.code === 0 && l.value === "BLOCK") {
      const i = me(t);
      l = t.lastReadGroup, i.handle || (i.handle = a++), i.name && (e[i.name] = i);
    } else
      l = t.next();
  return e;
}
function me(t) {
  const e = {};
  let a = t.next();
  for (; a.value !== "EOF"; ) {
    switch (a.code) {
      case 1:
        e.xrefPath = a.value, a = t.next();
        break;
      case 2:
        e.name = a.value, a = t.next();
        break;
      case 3:
        e.name2 = a.value, a = t.next();
        break;
      case 5:
        e.handle = a.value, a = t.next();
        break;
      case 8:
        e.layer = a.value, a = t.next();
        break;
      case 10:
        e.position = y(t, a), a = t.next();
        break;
      case 67:
        e.paperSpace = a.value === 1, a = t.next();
        break;
      case 70:
        a.value !== 0 && (e.type = a.value), a = t.next();
        break;
      case 100:
        a = t.next();
        break;
      case 330:
        e.ownerHandle = a.value, a = t.next();
        break;
      case 0:
        if (a.value === "ENDBLK") break;
        e.entities = R(t, !0), a = t.lastReadGroup;
        break;
      default:
        a = t.next();
    }
    if (a.code === 0 && a.value === "ENDBLK") {
      a = t.next();
      break;
    }
  }
  return e;
}
function ge(t) {
  const e = {}, a = {}, l = /* @__PURE__ */ new Map();
  let i = t.next();
  for (; !t.isEOF(); ) {
    if (i.code === 0) {
      if (i.value === "ENDSEC") break;
      if (i.value === "MLEADERSTYLE") {
        const o = re(t);
        o.handle && (e[o.handle.toUpperCase()] = o), i = t.lastReadGroup;
        continue;
      }
      if (i.value === "GROUP") {
        const o = Oe(t);
        o.handle && (a[o.handle] = o), i = t.lastReadGroup;
        continue;
      }
      if (i.value === "DICTIONARY") {
        const o = Pe(t);
        o.handle && l.set(o.handle, { entries: o.entries }), i = t.lastReadGroup;
        continue;
      }
    }
    i = t.next();
  }
  let s;
  for (const { entries: o } of l.values()) {
    const d = o.get("ACAD_GROUP");
    if (d) {
      s = d.toUpperCase();
      break;
    }
  }
  if (s) {
    const o = l.get(s);
    if (o)
      for (const [d, u] of o.entries) {
        const k = a[u.toUpperCase()];
        k && (k.name = d);
      }
  }
  const b = { mLeaderStyles: e };
  return Object.keys(a).length > 0 && (b.groups = a), b;
}
function re(t) {
  const e = { handle: "" };
  let a = t.next();
  for (; !t.isEOF() && a.code !== 0; ) {
    switch (a.code) {
      case 5:
        e.handle = String(a.value).toUpperCase();
        break;
      case 3:
        e.name = String(a.value);
        break;
      case 91:
        e.leaderLineColorRaw = a.value;
        break;
      case 93:
        e.textColorRaw = a.value;
        break;
      case 94:
        e.blockColorRaw = a.value;
        break;
    }
    a = t.next();
  }
  return e;
}
function Oe(t) {
  const e = {
    handle: "",
    isUnnamed: !1,
    isSelectable: !1,
    entityHandles: []
  };
  let a = t.next();
  for (; !t.isEOF() && a.code !== 0; ) {
    switch (a.code) {
      case 5:
        e.handle = String(a.value).toUpperCase();
        break;
      case 300:
        e.description = String(a.value);
        break;
      case 70:
        e.isUnnamed = a.value === 1;
        break;
      case 71:
        e.isSelectable = a.value === 1;
        break;
      case 340:
        e.entityHandles.push(String(a.value).toUpperCase());
        break;
    }
    a = t.next();
  }
  return e;
}
function Pe(t) {
  let e = "";
  const a = /* @__PURE__ */ new Map();
  let l, i = t.next();
  for (; !t.isEOF() && i.code !== 0; ) {
    switch (i.code) {
      case 5:
        e || (e = String(i.value).toUpperCase());
        break;
      case 3:
        l = String(i.value);
        break;
      case 350:
      case 360:
        l !== void 0 && (a.set(l, String(i.value)), l = void 0);
        break;
    }
    i = t.next();
  }
  return { handle: e, entries: a };
}
function Le(t) {
  return t.type === "LINE";
}
function Te(t) {
  return t.type === "CIRCLE";
}
function Fe(t) {
  return t.type === "ARC";
}
function Ae(t) {
  return t.type === "POLYLINE" || t.type === "LWPOLYLINE";
}
function Ne(t) {
  return t.type === "SPLINE";
}
function Ie(t) {
  return t.type === "TEXT" || t.type === "MTEXT";
}
function Ce(t) {
  return t.type === "DIMENSION";
}
function He(t) {
  return t.type === "INSERT";
}
function Ve(t) {
  return t.type === "SOLID";
}
function _e(t) {
  return t.type === "ELLIPSE";
}
function Me(t) {
  return t.type === "POINT";
}
function Be(t) {
  return t.type === "3DFACE";
}
function Se(t) {
  return t.type === "HATCH";
}
function Ge(t) {
  return t.type === "LEADER";
}
function Ye(t) {
  return t.type === "MULTILEADER";
}
function ze(t) {
  return t.type === "ATTDEF";
}
function Xe(t) {
  return t.type === "ATTRIB";
}
function Ue(t) {
  return t.type === "MLINE";
}
function je(t) {
  return t.type === "XLINE" || t.type === "RAY";
}
function De(t) {
  return t.type === "REGION";
}
function S(t) {
  if (!t || t.length === 0) return;
  const e = /* @__PURE__ */ new Map();
  for (const a of t)
    if (Se(a))
      for (const l of a.boundaryPaths)
        for (const i of l.sourceObjectHandles ?? [])
          e.set(i, a);
  if (e.size !== 0)
    for (const a of t) {
      if (!De(a) || a.handle == null) continue;
      const l = String(a.handle).toUpperCase(), i = e.get(l);
      if (!i) continue;
      const s = i.boundaryPaths.filter(
        (b) => b.sourceObjectHandles?.includes(l)
      );
      s.length !== 0 && (a.contourBoundary = s, i.extrusionDirection && (a.contourExtrusionDirection = i.extrusionDirection));
    }
}
const Re = "AutoCAD Binary DXF";
function We(t) {
  if (t.startsWith(Re))
    throw new Error("Binary DXF format is not supported. Save the file as ASCII (text) DXF and try again.");
  const e = {}, a = t.split(/\r\n|\r|\n/g), l = new L(a);
  if (!l.hasNext()) throw new Error("Empty file");
  let i = l.next();
  for (; !l.isEOF(); )
    if (i.code === 0 && i.value === "SECTION") {
      if (i = l.next(), i.code !== 2) {
        i = l.next();
        continue;
      }
      i.value === "HEADER" ? (e.header = T(l), i = l.lastReadGroup) : i.value === "BLOCKS" ? (e.blocks = we(l), i = l.lastReadGroup) : i.value === "ENTITIES" ? (e.entities = R(l, !1), i = l.lastReadGroup) : i.value === "TABLES" ? (e.tables = N(l), i = l.lastReadGroup) : i.value === "OBJECTS" && (e.objects = ge(l), i = l.lastReadGroup);
    } else
      i = l.next();
  if (e.entities || (e.entities = []), S(e.entities), e.blocks)
    for (const s in e.blocks)
      S(e.blocks[s].entities);
  return e;
}
function Ke(t, e, a) {
  const l = {};
  t.entities.forEach((o) => {
    const d = o.type;
    l[d] = (l[d] || 0) + 1;
  });
  let i = 0;
  t.tables?.layer?.layers && (i = Object.keys(t.tables.layer.layers).length);
  const s = t.blocks ? Object.keys(t.blocks).length : 0;
  let b;
  return t.header?.$ACADVER && (b = String(t.header.$ACADVER)), {
    fileName: e,
    fileSize: a,
    totalEntities: t.entities.length,
    entitiesByType: l,
    layersCount: i,
    blocksCount: s,
    autocadVersion: b
  };
}
const c = [
  0,
  //  0 = Unitless (sentinel — never used for math)
  25.4,
  //  1 = Inches
  304.8,
  //  2 = Feet
  1609344,
  //  3 = Miles
  1,
  //  4 = Millimeters
  10,
  //  5 = Centimeters
  1e3,
  //  6 = Meters
  1e6,
  //  7 = Kilometers
  254e-7,
  //  8 = Microinches
  0.0254,
  //  9 = Mils
  914.4,
  // 10 = Yards
  1e-7,
  // 11 = Angstroms
  1e-6,
  // 12 = Nanometers
  1e-3,
  // 13 = Microns
  100,
  // 14 = Decimeters
  1e4,
  // 15 = Decameters
  1e5,
  // 16 = Hectometers
  1e12,
  // 17 = Gigameters
  1496e11,
  // 18 = Astronomical units
  9461e15,
  // 19 = Light years
  3086e16
  // 20 = Parsecs
];
function qe(t, e) {
  return t === 0 || e === 0 || t === e || t < 0 || t >= c.length || e < 0 || e >= c.length ? 1 : c[e] / c[t];
}
function Je(t) {
  return t < 0 || t >= c.length ? 0 : c[t];
}
export {
  F as A,
  Fe as a,
  Te as b,
  _e as c,
  Ne as d,
  Ae as e,
  Me as f,
  Ve as g,
  Be as h,
  Le as i,
  Se as j,
  De as k,
  Ce as l,
  Ge as m,
  Ye as n,
  He as o,
  We as p,
  Ie as q,
  qe as r,
  ze as s,
  Ue as t,
  je as u,
  Xe as v,
  Ke as w,
  Je as x
};
